<xemex-authorization-container [isLoading]="authStore.isLoading()">
  <div class="flex flex-col gap-6">
    <header class="flex flex-col gap-1">
      <h1 class="text-2xl font-bold">{{ 'setNewPassword.title' | translate }}</h1>
      <p class="text-sm text-neutral">{{ 'setNewPassword.subtitle' | translate }}</p>
    </header>

    @if (authStore.authFeedback(); as feedback) {
      <xemex-alert-banner [variant]="feedback.variant">
        {{ feedback.key | translate }}
      </xemex-alert-banner>
    }

    <form
      class="flex flex-col gap-4"
      [formGroup]="setNewPasswordForm"
      (submit)="onSetNewPassword()"
    >
      <xemex-text-field
        formControlName="password"
        type="password"
        prefixIcon="lock"
        autocomplete="new-password"
        [label]="'setNewPassword.password' | translate"
        [placeholder]="'setNewPassword.placeholderPassword' | translate"
        [invalid]="passwordControl.invalid && passwordControl.touched"
        [errorText]="
          passwordControl.hasError('required')
            ? ('error.required' | translate: { field: 'setNewPassword.password' | translate })
            : passwordControl.hasError('passwordInvalid')
              ? ('error.passwordNotStrong' | translate)
              : ''
        "
      />

      <xemex-text-field
        formControlName="confirmPassword"
        type="password"
        prefixIcon="lock"
        autocomplete="new-password"
        [label]="'setNewPassword.confirmPassword' | translate"
        [placeholder]="'setNewPassword.placeholderPassword' | translate"
        [invalid]="confirmPasswordControl.invalid && confirmPasswordControl.touched"
        [errorText]="
          confirmPasswordControl.hasError('required')
            ? ('error.required'
              | translate: { field: 'setNewPassword.confirmPassword' | translate })
            : confirmPasswordControl.hasError('notMatched')
              ? ('error.confirmPasswordInvalid' | translate)
              : confirmPasswordControl.hasError('passwordInvalid')
                ? ('error.passwordNotStrong' | translate)
                : ''
        "
      />

      <xemex-filled-button type="submit" [fullWidth]="true" [loading]="authStore.isLoading()">
        {{ 'setNewPassword.btnSetPassword' | translate }}
      </xemex-filled-button>
    </form>
  </div>
</xemex-authorization-container>
